<div class="loading-overlay" *ngIf="isLoading">
  <div class="animation-container">
    <!-- Your Vengreso SVG Logo -->
    <svg
      class="vengreso-logo"
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w.org/2000/svg"
      viewBox="0 0 159.69 93.91"
    >
      <defs>
        <style>
          .cls-1 {
            fill: #fff;
          }
          .cls-2 {
            fill: #f15a2a;
          }
          .cls-3 {
            fill: #5f177f;
          }
        </style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g>
          <path
            class="cls-3"
            d="M132.67,90.47l-4.05-4.45-.64-2.25c-2.83-4.55-11.43-11.16-15.61-14.21l-10.52-8.56c-.35,2.65-2.37,4.77-5.11,4.77h-2.93v-18.32s0-.06,0-.08c-.2-.2-.31-.32-.31-.32,0-.05-.01-.1-.02-.15-.07-.05-.15-.11-.21-.16,0,0-.51-.5-10.93-7.18S39.73,13.6,39.73,13.6c0,0,8.9,10.1,16.47,20.33C29.79,17.84,0,0,0,0c0,0,9.52,10.81,20.76,24.81l12.59,8.66-7.25-1.92c3.34,4.27,6.71,8.7,9.95,13.12l10.19,5.83-22.16-7.86c5.28,5.03,21.2,18.07,25.07,21.48,19.1,16.86,40.34,19.76,52.14,18.62,6.74-3.24-.17-11.87-.17-11.87,4.41,5.43,5.84,8.95,5.48,11.18l21.25,8.76c4.49,2.13,4.78,2.89,4.72,3.1,1.08-1.42.11-3.43.11-3.43ZM122.56,83.39l-.33-1.75,2.51,2.01-2.17-.25Z"
          />
          <g>
            <path
              class="cls-1"
              d="M68.45,48.05h-8.65v3.89h7.95v3.93h-7.95v4.25c0,2.54-2.06,4.61-4.61,4.61h-.54v-20.6h13.79v3.93Z"
            />
            <path class="cls-1" d="M74.85,64.72h-4.84v-21.52h1c2.12,0,3.85,1.72,3.85,3.85v17.68Z" />
            <path
              class="cls-1"
              d="M92.51,49.18l-8.27,22.38h-.06c-2.47,0-4.18-2.49-3.28-4.79l.92-2.43-5.7-15.16h5.09l3.26,9.74,3.06-9.74h4.98Z"
            />
            <path
              class="cls-2"
              d="M116.37,64.72h-5.15v-13.65l-3.75,8.81h-3.53l-3.75-8.81v9.5c0,2.29-1.86,4.15-4.15,4.15h-.72v-20.6h5.96l4.56,10.17,4.55-10.17h5.96v20.6Z"
            />
            <path
              class="cls-2"
              d="M125.93,65.09c-1.58,0-2.96-.15-4.16-.46s-2.3-.68-3.33-1.13v-4.9h.47c1.03.88,2.17,1.55,3.42,2.02,1.25.47,2.45.71,3.62.71.29,0,.68-.03,1.17-.1s.87-.17,1.17-.3c.36-.16.66-.38.91-.66s.37-.65.37-1.11c0-.52-.2-.94-.61-1.26-.41-.32-.89-.56-1.45-.71-.7-.18-1.45-.36-2.25-.53-.8-.17-1.54-.37-2.23-.61-1.6-.56-2.74-1.32-3.43-2.27s-1.04-2.14-1.04-3.57c0-1.93.82-3.49,2.45-4.68,1.63-1.19,3.67-1.79,6.11-1.79,1.23,0,2.45.12,3.66.37,1.21.25,2.3.59,3.26,1.01v4.7h-.46c-.77-.65-1.7-1.21-2.8-1.66-1.1-.45-2.23-.68-3.4-.68-.45,0-.86.03-1.22.1-.36.06-.74.19-1.13.37-.32.15-.6.37-.84.66-.24.29-.35.62-.35.98,0,.53.19.94.56,1.25.37.31,1.1.59,2.17.84.69.16,1.36.31,2,.46s1.33.35,2.05.61c1.43.52,2.49,1.21,3.19,2.08s1.04,2.02,1.04,3.45c0,2.05-.8,3.69-2.41,4.94-1.61,1.25-3.78,1.87-6.52,1.87Z"
            />
            <path
              class="cls-2"
              d="M154.68,63.54c-.9.37-2.08.73-3.52,1.08-1.44.35-2.87.53-4.27.53-3.24,0-5.82-.93-7.74-2.8-1.92-1.87-2.88-4.52-2.88-7.95,0-3.23.96-5.81,2.88-7.76,1.92-1.95,4.55-2.92,7.89-2.92,1.72,0,3.13.16,4.21.49,1.08.33,2.19.77,3.35,1.33v4.83h-.47c-.25-.19-.61-.47-1.07-.82-.47-.35-.92-.66-1.36-.91-.52-.29-1.11-.55-1.79-.76-.68-.21-1.4-.32-2.15-.32-.88,0-1.69.14-2.42.42-.73.28-1.38.7-1.95,1.27-.54.55-.98,1.25-1.29,2.1-.32.85-.48,1.83-.48,2.96,0,2.41.6,4.18,1.81,5.33,1.21,1.14,2.86,1.72,4.95,1.72.18,0,.4,0,.65-.01.25,0,.47-.02.65-.04v-4.04h-3.46c-1.31,0-2.37-1.06-2.37-2.37v-1.49h10.83v10.14Z"
            />
            <path
              class="cls-2"
              d="M159.69,44.64c0,1.01-.79,1.8-1.83,1.8s-1.84-.79-1.84-1.8.81-1.78,1.84-1.78,1.83.79,1.83,1.78ZM156.49,44.64c0,.79.59,1.42,1.39,1.42s1.36-.63,1.36-1.41-.58-1.43-1.37-1.43-1.38.64-1.38,1.42ZM157.58,45.57h-.41v-1.78c.16-.03.39-.05.68-.05.34,0,.49.05.62.13.1.08.17.22.17.39,0,.2-.15.35-.37.41v.02c.17.07.27.2.33.43.05.27.09.38.13.45h-.45c-.05-.07-.09-.23-.14-.44-.03-.2-.14-.28-.37-.28h-.2v.72ZM157.59,44.56h.2c.23,0,.41-.08.41-.26,0-.16-.12-.27-.38-.27-.11,0-.18.01-.23.02v.51Z"
            />
          </g>
        </g>
      </g>
    </svg>
    <!-- The text now updates dynamically -->
    <div class="loading-text-container">
      <p class="loading-text" *ngIf="currentMessage">{{ currentMessage }}</p>
      <p class="loading-text" *ngIf="!currentMessage">&nbsp;</p>
    </div>
  </div>
</div>
